import { FC } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import SharedProvider from '@provider/Shared'

import Export from '@view/Export'
import FollowUpFornecedorExterno from '@view/FollowUpFornecedor/Externo'

import AppRoutes from './app1'

const Routes: FC = () => {
  return (
    <Router basename="/">
      <Switch>
        {/* <Route
          path="/auth/callback"
          render={routerProps => (
            <Callback
              onSuccess={() => {
                routerProps.history.push('/')
              }}
              userManager={userManager}
            >
              <AuthLoading />
            </Callback>
          )}
        /> */}
        <Route exact path="/relatorio-geral">
          <Export />
        </Route>
        <Route path="/follow-up-fornecedor/externo/:token">
          <FollowUpFornecedorExterno />
        </Route>
        <SharedProvider>
          <AppRoutes />
        </SharedProvider>
      </Switch>
    </Router>
  )
}

export default Routes
